import { render, staticRenderFns } from "./panelDashboard.vue?vue&type=template&id=5ef47ee8&scoped=true"
import script from "./panelDashboard.vue?vue&type=script&lang=js"
export * from "./panelDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef47ee8",
  null
  
)

export default component.exports